/** Props to prevent copy/paste on sensitive input fields */
export const NO_PASTE_PROPS = {
  onCut: (e: React.ClipboardEvent) => e.preventDefault(),
  onCopy: (e: React.ClipboardEvent) => e.preventDefault(),
  onPaste: (e: React.ClipboardEvent) => { e.preventDefault() },
}
